import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import DropdownArrow from './DropdownArrow';
import SvgCheckmark from '../icons/SvgCheckmark';
const ExpandableArea = ({ title, done, children, expandedStart = false }) => {
    const [expanded, setExpanded] = useState(expandedStart);
    return (_jsxs("div", { className: "p-4 border border-gray-300 my-2", children: [_jsxs("h4", { onClick: () => setExpanded(!expanded), children: [_jsx(DropdownArrow, { expanded: expanded }), title, done && (_jsx("div", { className: "inline-block relative top-2 left-05 rounded-full px-4", children: _jsx(SvgCheckmark, { className: "text-black h-4 w-4 fill-current" }) }))] }), expanded && children] }));
};
export default ExpandableArea;
